import { useCallback } from "react";
import { Box } from "@mui/material";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";

import Text from "../text/Text";
import { selectAuthSubtitle, selectMethod } from "../messages";
import { mfaMethods } from "../constants";
import CommonDrawer from "../drawer/CommonDrawer";

const SelectAuthenticationMethodDrawer = ({
  openModal,
  setOpenModal,
  mfaConfigurations,
  onChangeMethod,
  isFromBrowser,
}) => {
  const renderBody = useCallback(() => {
    return (
      <Box>
        <Text
          size={isFromBrowser ? 16 : 14}
          font="regular"
          className="grey-text"
        >
          {selectAuthSubtitle}
        </Text>
        {mfaConfigurations.map((mfaConfig) => (
          <Box
            key={mfaConfig.mfa_type}
            className="mode-box"
            padding="16px 20px"
            marginTop={2}
            onClick={() => {
              onChangeMethod(mfaConfig);
            }}
          >
            <Box display="flex" alignItems="center" gap={isFromBrowser ? 2 : 1}>
              <img
                alt="icon"
                src={mfaMethods[mfaConfig.mfa_type].icon}
                height={isFromBrowser ? 24 : 22}
                width={isFromBrowser ? 24 : 22}
              />
              <Text
                className="default-text"
                font="semibold"
                size={isFromBrowser ? 16 : 13}
              >
                {mfaMethods[mfaConfig.mfa_type].title}
              </Text>
            </Box>
            <KeyboardArrowRightOutlined
              sx={{
                marginLeft: "14px",
                color: "#848B9E",
              }}
            />
          </Box>
        ))}
      </Box>
    );
  }, [mfaConfigurations, isFromBrowser, onChangeMethod]);

  return (
    <CommonDrawer
      anchor="bottom"
      open={openModal}
      onClose={() => setOpenModal(false)}
      className="select-auth-method-drawer"
      sx={{
        position: "absolute !important",
      }}
    >
      <Box className="drawer-container">
        <Box className="drawer-header">
          <Text className="drawer-title">{selectMethod}</Text>
          <CloseIcon
            className="close-icon"
            onClick={() => setOpenModal(false)}
          />
        </Box>
        <Box className="drawer-body">{renderBody()}</Box>
      </Box>
    </CommonDrawer>
  );
};

export default SelectAuthenticationMethodDrawer;
